(function () {
  const GEO_ENDPOINT = "https://teddy-baldassarre.vercel.app/api/geo-detect";
  const REGION_KEY = "tb_geo_region";

  function readCachedRegion() {
    try {
      return sessionStorage.getItem(REGION_KEY);
    } catch (e) {
      return null;
    }
  }

  let regionPromise = null;
  function getRegion() {
    const cached = readCachedRegion();
    if (cached !== null) return Promise.resolve(cached);
    if (!regionPromise) {
      regionPromise = fetch(GEO_ENDPOINT)
        .then((r) => r.json())
        .then(({ regionCode = "" }) => {
          try {
            sessionStorage.setItem(REGION_KEY, regionCode);
          } catch (e) {}
          return regionCode;
        })
        .catch(() => "");
    }
    return regionPromise;
  }

  class PdpStockRegion extends HTMLElement {
    async connectedCallback() {
      if (!this.hidden) return; // design mode renders visible
      const regions = (this.dataset.regions || "").split(",").filter(Boolean);
      if (!regions.length) return;
      const region = (await getRegion()).toUpperCase();
      if (regions.includes(region)) this.hidden = false;
    }
  }

  if (!customElements.get("pdp-stock-region")) {
    customElements.define("pdp-stock-region", PdpStockRegion);
  }
})();
